import { FriendshipWithUser } from '../models';
import { FriendshipRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetFriendsUseCase {
  constructor(private friendshipRepository: FriendshipRepository) {}

  async execute(userId: string, limit?: number, offset?: number): Promise<FriendshipWithUser[]> {
    logger.debug('GetFriends', 'Fetching friends', { userId });

    const friends = await this.friendshipRepository.getFriends(userId, limit, offset);

    logger.debug('GetFriends', 'Found friends', { count: friends.length });

    return friends;
  }
}
